import { ChevronRight } from '@mui/icons-material'
import { Box, Typography, alpha, useTheme } from '@mui/material'
import { Link } from 'react-router-dom'

import { TLink } from '~/features/settings/models'
import rem from '~/utils/ui'

function Item({ label, url }: TLink) {
  const theme = useTheme()
  return (
    <Box
      component={Link}
      to={url}
      target="_blank"
      sx={{
        paddingBlock: 0.5,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        cursor: 'pointer',
        textDecoration: 'none',
        color: theme.palette.mainFont,
        borderBottom: `${rem(1)} solid ${theme.palette.mainFont}`,
        '&:hover': {
          backgroundColor: alpha(theme.palette.tertiary1, 0.7),
        },
      }}
    >
      <Typography
        variant="subtitle1"
        sx={{
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          maxWidth: 200,
        }}
      >
        {label}
      </Typography>
      <ChevronRight sx={{ fontSize: 16 }} />
    </Box>
  )
}

export default Item
